export default __webpack_public_path__ + "static/media/malting.a3a02a1a.jpg";